export type TJsonifyObj = object | string | number;

export function isAtomic(val: TJsonifyObj) {
  const valType = typeof val;
  return valType === "string" || valType === "number";
}

function tryJson(val: string): TJsonifyObj {
  try {
    if (val.trim().startsWith("{") || val.trim().startsWith("[")) {
      const json = JSON.parse(val);
      return jsonify(json);
    }
  } catch (_) {
    // handle if needed
  }
  return val;
}

export function jsonify(obj: TJsonifyObj): TJsonifyObj {
  if (!obj) return obj;
  const safeObj = Object.freeze(obj);
  if (typeof safeObj === "string") return tryJson(safeObj);
  if (isAtomic(safeObj)) return safeObj;
  if (Array.isArray(safeObj)) return safeObj.map((i) => jsonify(i));
  const res: Record<string, TJsonifyObj> = {};
  for (const [k, v] of Object.entries(safeObj)) {
    res[k] = jsonify(v);
  }
  return res;
}
